import React from "react";
import { useState } from "react";
import { Button, Col, Container, FormGroup, Row } from "reactstrap";
import { Formik, Field, ErrorMessage, Form } from "formik";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { HandleProductSubmit } from "../../../../actions/settings/product_actions";
import { TextField, CustomModal } from "../../../../constants";
import * as Yup from "yup";

const AddProduct = (props) => {
  const dispatch = useDispatch();
  const formikRef = React.useRef();
  const { current_product_obj, is_processing } = useSelector(
    (state) => state.productState,
    shallowEqual
  );

  const [validateAfterSubmit, setValidateAfterSubmit] = useState(false);

  const validate = Yup.object({
    product_name: Yup.string().required("Product name is required"),
    description: Yup.string().required("Description is required"),
  });

  const { modal, toggle } = props;

  return (
    <>
      <CustomModal
        modal={modal}
        toggle={toggle}
        tittle="Add Product"
        is_processing={is_processing}
      >
        <Formik
          enableReinitialize
          initialValues={{
            product_name: current_product_obj.product_name,
            description: current_product_obj.description,
          }}
          validationSchema={validate}
          validateOnChange={validateAfterSubmit}
          validateOnBlur={true}
          ref={formikRef}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            setValidateAfterSubmit(true);
            dispatch(
              HandleProductSubmit(values, toggle, setErrors, setSubmitting)
            );
          }}
        >
          {(formik) => (
            <Container>
              <Form>
                <FormGroup>
                  <Row className="mt-3 ml-1">
                    <Col lg={12} md={12} sm={12} className="my-2">
                      <TextField
                        name="product_name"
                        type="text"
                        value={formik.values.product_name}
                        placeholder="Product Name"
                      />
                    </Col>
                    <Col lg={12} md={12} sm={12} className="my-2">
                      <Field
                        as="textarea"
                        name="description"
                        value={formik.values.description}
                        placeholder="product description"
                        className={`custom-select form-control ${
                          formik.errors.description ? `is-invalid mb-2` : ""
                        }`}
                      ></Field>
                      <ErrorMessage
                        component="div"
                        name="description"
                        className="error"
                      />
                    </Col>
                    <Col lg={12} md={12} sm={12} className="mt-3">
                      <Button
                        type="submit"
                        className="btn btn-pay btn-block"
                        block
                        disabled={is_processing}
                      >
                        <span className="pay-btn-text text-white ">
                          {is_processing ? "Saving ..." : "Create"}
                        </span>
                      </Button>
                    </Col>
                  </Row>
                </FormGroup>
              </Form>
            </Container>
          )}
        </Formik>
      </CustomModal>
    </>
  );
};

export default AddProduct;
